
const Manager = () => import('../views/System/manager/index');
const Area = () => import('../views/System/area/index.vue');

export default [
  {
    path: '/area',
    name: '大区管理',
    component: Area,
    meta: [{ name: '大区管理' }]
  },
  {
    path: '/manager',
    name: '管理员维护',
    component: Manager,
    meta: [{ name: '管理员维护' }]
  },
];
